import classNames from "classnames";
import { BoxArrowLeft } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

import Button from "@/components/ui/buttons/button";
import { BASE_URL } from "@/constants";
import { IS_ME_LINK, LANDING_URL } from "@/constants/app";
import { EXTERNAL_ROUTES } from "@/constants/routes";
import logoutEvent from "@/services/analyticsEvents/logoutEvent";
import { authService, useAuthService } from "@/services/authService";
import { localizedHref } from "@/utils/localizedHref";

import styles from "./LogoutButton.module.scss";

interface ILogoutButtonProps {
  className?: string;
}

function LogoutButton({ className }: ILogoutButtonProps) {
  const { t } = useTranslation();
  const { isSwitchedUser, username } = useAuthService();

  const handleLogout = () => {
    if (isSwitchedUser) {
      window.location.href = localizedHref(
        `${IS_ME_LINK ? LANDING_URL : BASE_URL}${EXTERNAL_ROUTES.SWITCH_USER_EXIT}?_switch_user=_exit&username=${username}&exactUsername=1`
      );
      return;
    }
    logoutEvent();
    authService.logout();
  };

  return (
    <Button
      variant="link"
      className={classNames(
        styles.btn,
        "text-decoration-none logout",
        className
      )}
      onClick={handleLogout}
    >
      <span className="d-flex align-items-center gap-3 w-100">
        <BoxArrowLeft className="fs-7" />
        <span className="fs-8">{isSwitchedUser ? "Exit" : t("logout")}</span>
      </span>
    </Button>
  );
}

export default LogoutButton;
